import { post } from '@/request/rarbActRequest';

let basePath = '/wx/y23/yfns';

export function wxRaffle(params) {
  return post(basePath + '/raffle', params);
}

export function zlbGetUser(params) {
  return post(basePath + '/zlb/getUser', params);
}

export function zlbRaffle(params) {
  return post(basePath + '/zlb/raffle', params);
}

export function raxwGetUser(params) {
  return post(basePath + '/raxw/getUser', params);
}

export function raxwRaffle(params) {
  return post(basePath + '/raxw/raffle', params);
}

export function userPrice(params) {
  return post(basePath + '/user/price', params);
}

export function userInfo(params) {
  return post(basePath + '/user/info', params);
}
